(() => {
  'use strict';

  const labels = JSON.parse(document.getElementById('nzc-feedback-labels')?.textContent || '{}');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
    style: 'currency', currency: labels.currency || 'NZD'
  }).format(cents / 100);

  const closeMenus = except => {
    document.querySelectorAll('.nzc-nav-parent.is-open').forEach(parent => {
      if (parent === except) return;
      parent.classList.remove('is-open');
      parent.querySelector('.nzc-nav-expand')?.setAttribute('aria-expanded', 'false');
    });
  };
  document.querySelectorAll('.nzc-nav-parent').forEach(parent => {
    const button = parent.querySelector('.nzc-nav-expand');
    button?.addEventListener('click', () => {
      const next = !parent.classList.contains('is-open');
      closeMenus(parent);
      parent.classList.toggle('is-open', next);
      button.setAttribute('aria-expanded', String(next));
    });
    parent.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeMenus();
        button?.focus();
      }
    });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.nzc-nav-parent')) closeMenus();
  });

  document.querySelectorAll('[data-price-range]').forEach(range => {
    const minSlider = range.querySelector('[data-price-min-slider]');
    const maxSlider = range.querySelector('[data-price-max-slider]');
    const minInput = range.querySelector('[data-price-min-input]');
    const maxInput = range.querySelector('[data-price-max-input]');
    const minLabel = range.querySelector('[data-price-min-label]');
    const maxLabel = range.querySelector('[data-price-max-label]');
    if (!minSlider || !maxSlider || !minInput || !maxInput) return;
    const sync = changed => {
      let low = Number(minSlider.value);
      let high = Number(maxSlider.value);
      if (low > high) {
        if (changed === minSlider) high = low;
        else low = high;
      }
      minSlider.value = String(low);
      maxSlider.value = String(high);
      minInput.value = low > 0 ? String(low) : '';
      maxInput.value = high < Number(maxSlider.max) ? String(high) : '';
      minLabel.textContent = `${labels.currency_symbol || '$'}${low}`;
      maxLabel.textContent = `${labels.currency_symbol || '$'}${high}`;
      range.style.setProperty('--price-low', `${100 * low / Math.max(1, Number(maxSlider.max))}%`);
      range.style.setProperty('--price-high', `${100 * high / Math.max(1, Number(maxSlider.max))}%`);
    };
    minSlider.addEventListener('input', () => sync(minSlider));
    maxSlider.addEventListener('input', () => sync(maxSlider));
    sync();
  });

  document.querySelectorAll('[data-nzc-tag-filter]').forEach(link => {
    const destination = new URL(link.href, location.origin);
    const currentParameters = new URLSearchParams(location.search);
    currentParameters.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'sort_by') destination.searchParams.append(key, value);
    });
    link.href = destination.href;
  });

  const placements = {
    rating: ['.product h1', 'afterend'],
    knocking: ['.product .prep:not(.kit-contents) .prep-body', 'beforeend'],
    'knocking-service': ['.product h1', 'afterend'],
    shoe: ['.product .nzc-measurement-first', 'afterend'],
    'shoe-faq': ['#care h2', 'afterend'],
    returns: ['.product .reassurance', 'afterend'],
    quote: ['.product .nzc-payment-heading', 'beforebegin']
  };
  document.querySelectorAll('[data-nzc-place]').forEach(element => {
    const [selector, position] = placements[element.dataset.nzcPlace] || [];
    const target = selector && document.querySelector(selector);
    if (target) target.insertAdjacentElement(position, element);
  });
  document.querySelectorAll('#nzc-service option').forEach(option => {
    if (option.textContent.includes('7+ MATCH READY')) option.textContent = option.textContent.replace('7+ MATCH READY', '7+ hours hand knocking');
  });
  document.addEventListener('variant:change', event => {
    const button = document.querySelector('.nzc-product-quote');
    const variant = event.detail?.variant;
    if (!button || !variant) return;
    button.dataset.quoteVariant = String(variant.id);
    button.dataset.quoteOption = variant.title || '';
    button.dataset.quotePrice = String(variant.price);
    button.disabled = !variant.available;
  });

  const gallery = document.querySelector('.product .gallery');
  if (gallery) {
    const photo = gallery.querySelector('.photo');
    const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
    if (photo && thumbs.length > 1) {
      const activeIndex = () => Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
      const move = delta => thumbs[(activeIndex() + delta + thumbs.length) % thumbs.length].click();
      const previous = document.createElement('button');
      const next = document.createElement('button');
      previous.type = next.type = 'button';
      previous.className = 'nzc-gallery-arrow nzc-gallery-arrow--previous';
      next.className = 'nzc-gallery-arrow nzc-gallery-arrow--next';
      previous.setAttribute('aria-label', labels.previous_image || 'Previous image');
      next.setAttribute('aria-label', labels.next_image || 'Next image');
      previous.textContent = '‹';
      next.textContent = '›';
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      photo.append(previous, next);
      let startX = null;
      let swipeTime = 0;
      photo.addEventListener('touchstart', event => {
        startX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      photo.addEventListener('touchend', event => {
        if (startX == null) return;
        const distance = (event.changedTouches[0]?.clientX ?? startX) - startX;
        startX = null;
        if (Math.abs(distance) < 45) return;
        swipeTime = Date.now();
        move(distance < 0 ? 1 : -1);
      }, { passive: true });
      photo.addEventListener('click', event => {
        if (Date.now() - swipeTime < 450 && event.target.closest('[data-zoom]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
  }

  const quoteKey = 'nzc-club-quote-v1';
  const readQuote = () => {
    try {
      const value = JSON.parse(localStorage.getItem(quoteKey) || '[]');
      return Array.isArray(value) ? value.filter(item => item && /^\d+$/.test(String(item.variantId)) && Number.isSafeInteger(Number(item.quantity)) && item.quantity > 0 && item.quantity <= 999 && Number.isSafeInteger(Number(item.price)) && item.price >= 0 && /^\/products\//.test(item.url || '')).slice(0, 50) : [];
    } catch (_) { return []; }
  };
  const writeQuote = items => {
    try { localStorage.setItem(quoteKey, JSON.stringify(items)); } catch (_) { return false; }
    return true;
  };
  const builder = document.querySelector('[data-quote-builder]');
  let quoteDialog;
  const showQuoteAdded = (button, item) => {
    if (!quoteDialog) {
      quoteDialog = document.createElement('dialog');
      quoteDialog.className = 'nzc-quote-added-dialog';
      quoteDialog.setAttribute('aria-labelledby', 'NzcQuoteAddedTitle');
      const title = document.createElement('h2'); title.id = 'NzcQuoteAddedTitle';
      title.textContent = labels.quote_added || 'Added to club quote';
      const detail = document.createElement('p'); detail.dataset.quoteAddedDetail = '';
      const note = document.createElement('p'); note.textContent = labels.quote_separate || '';
      const review = document.createElement('a'); review.className = 'nzc-button nzc-button--primary';
      review.href = '/pages/cricket-club-team-orders-nz#club-quote-builder';
      review.textContent = labels.quote_review || 'Review club quote';
      const keep = document.createElement('button'); keep.type = 'button';
      keep.className = 'nzc-button nzc-button--secondary';
      keep.textContent = labels.quote_continue || 'Continue shopping';
      keep.addEventListener('click', () => quoteDialog.close());
      quoteDialog.append(title, detail, note, review, keep);
      document.body.append(quoteDialog);
    }
    quoteDialog.querySelector('[data-quote-added-detail]').textContent = `${item.quantity} × ${item.title} — ${item.option}`;
    quoteDialog.addEventListener('close', () => button.focus(), { once: true });
    if (!quoteDialog.open) quoteDialog.showModal();
  };
  const renderQuote = () => {
    if (!builder) return;
    const list = builder.querySelector('[data-quote-list]');
    const field = builder.querySelector('[data-quote-field]');
    const items = readQuote();
    const retailTotal = items.reduce((total, item) => total + Number(item.price) * Number(item.quantity), 0);
    const total = builder.querySelector('[data-quote-total]');
    if (total) total.textContent = money(retailTotal);
    list.replaceChildren();
    if (!items.length) {
      const empty = document.createElement('p');
      empty.textContent = labels.quote_empty || 'No products selected yet.';
      list.append(empty);
      field.value = '';
      return;
    }
    items.forEach((item, index) => {
      const row = document.createElement('div');
      row.className = 'nzc-quote-row';
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = `${item.title}${item.option && item.option !== 'Default Title' ? ` - ${item.option}` : ''}`;
      const quantity = document.createElement('input');
      quantity.type = 'number';
      quantity.min = '1';
      quantity.max = '999';
      quantity.value = String(item.quantity);
      quantity.setAttribute('aria-label', `${labels.quote_quantity || 'Quantity'} for ${item.title}`);
      quantity.addEventListener('change', () => {
        const next = readQuote();
        if (!next[index]) return;
        next[index].quantity = Math.min(999, Math.max(1, Math.trunc(Number(quantity.value) || 1)));
        writeQuote(next);
        renderQuote();
      });
      const price = document.createElement('span');
      price.textContent = `${money(item.price)} ${labels.quote_each || 'each'} · ${money(item.price * item.quantity)}`;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = labels.quote_remove || 'Remove';
      remove.addEventListener('click', () => {
        const next = readQuote();
        next.splice(index, 1);
        writeQuote(next);
        renderQuote();
      });
      row.append(link, quantity, price, remove);
      list.append(row);
    });
    field.value = items.map(item => `${item.quantity} x ${item.title} | ${item.option} | Variant ${item.variantId} | catalogue ${money(item.price)} each | ${item.url}`).join('\n') + `\nRetail product subtotal: ${money(retailTotal)}. Delivery and final discount to be confirmed.`;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quote-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const productForm = button.classList.contains('nzc-product-quote') ? document.getElementById('nzc-product-form') : null;
    const helmetSize = productForm?.querySelector('[name="properties[Helmet size]"]:not(:disabled)');
    if (helmetSize && !productForm.reportValidity()) return;
    const item = {
      productId: button.dataset.quoteProduct,
      variantId: button.dataset.quoteVariant,
      title: button.dataset.quoteTitle,
      option: button.dataset.quoteOption,
      price: Number(button.dataset.quotePrice) || 0,
      url: (button.dataset.quoteUrl || '').split('?')[0] + '?variant=' + button.dataset.quoteVariant,
      quantity: button.classList.contains('nzc-product-quote') ? Math.min(999, Math.max(1, Math.trunc(Number(document.getElementById('nzc-product-form')?.querySelector('[name="quantity"]')?.value) || 1))) : 1
    };
    if (!item.variantId) return;
    if (helmetSize) {
      item.helmetSize = helmetSize.value;
      item.helmetModel = productForm.querySelector('[name="properties[Helmet]"]')?.value || '';
      const headMeasurement = productForm.querySelector('[data-helmet-measurement]:not(:disabled)');
      item.helmetMeasurementRequired = Boolean(headMeasurement);
      item.helmetHeadCm = headMeasurement?.value || '';
      item.option += ' · Helmet: ' + helmetSize.value;
      if (item.helmetHeadCm) item.option += ' · Head: ' + item.helmetHeadCm + ' cm';
      if (item.helmetModel) item.option += ' · ' + item.helmetModel;
    }
    const items = readQuote();
    const existing = items.find(value => value.variantId === item.variantId && (value.helmetSize || '') === (item.helmetSize || '') && (value.helmetHeadCm || '') === (item.helmetHeadCm || '') && (value.helmetModel || '') === (item.helmetModel || ''));
    if (!existing && items.length >= 50) {
      button.textContent = labels.quote_limit || 'Quote limit reached. Review your quote.';
      return;
    }
    if (existing) existing.quantity = Math.min(999, existing.quantity + item.quantity);
    else items.push(item);
    if (writeQuote(items)) {
      button.textContent = labels.quote_added || 'Added to club quote';
      renderQuote();
      showQuoteAdded(button, item);
    }
  }, true);
  if (document.querySelector('[data-club-submitted]')) {
    try { localStorage.removeItem(quoteKey); } catch (_) { }
  }
  renderQuote();
  window.addEventListener('storage', event => { if (event.key === quoteKey) renderQuote(); });

  const cartUpdates = document.querySelector('[data-nzc-cart-updates]');
  const cartSummary = document.querySelector('.cart-summary');
  if (cartUpdates && cartSummary) cartSummary.prepend(cartUpdates);

  const giftForm = document.getElementById('nzc-cart-form');
  const giftInput = document.getElementById('nzc-gift-order');
  const giftStatus = document.getElementById('nzc-gift-status');
  const giftValue = document.querySelector('[data-nzc-gift-value]');
  const giftDetail = document.querySelector('[data-nzc-gift-detail]');
  if (giftForm && giftInput && giftStatus && giftValue && giftDetail) {
    const root = window.Shopify?.routes?.root || '/';
    const requestDetail = giftInput.dataset.exchangeRequest;
    let savedValue = giftInput.dataset.savedValue === 'Yes' ? 'Yes' : '';
    let forceSave = false;
    let saving = null;
    let submitting = false;
    let resumeSubmit = false;
    let giftRevision = 0;
    let lockedControls = [];
    const selectedValue = () => giftInput.checked ? 'Yes' : '';
    const syncGiftFields = () => {
      giftValue.value = selectedValue();
      giftDetail.value = giftInput.checked ? requestDetail : '';
    };
    const showGiftStatus = state => {
      giftStatus.textContent = giftStatus.dataset[state];
      giftStatus.dataset.state = state;
      giftInput.setAttribute('aria-invalid', String(state === 'error'));
    };
    const unlock = () => {
      lockedControls.forEach(([control, disabled]) => { control.disabled = disabled; });
      lockedControls = [];
      giftForm.removeAttribute('aria-busy');
    };
    const persistGift = (verify = false) => {
      syncGiftFields();
      forceSave = forceSave || verify;
      if (saving) return saving;
      if (!forceSave && savedValue === selectedValue()) return Promise.resolve();
      saving = (async () => {
        while (forceSave || savedValue !== selectedValue()) {
          forceSave = false;
          const value = selectedValue();
          const detail = value ? requestDetail : '';
          showGiftStatus('saving');
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 12000);
          try {
            const response = await fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              keepalive: true,
              signal: controller.signal,
              body: JSON.stringify({ attributes: {
                'Gift order': value,
                'Gift exchange request': detail
              } })
            });
            if (!response.ok) throw new Error('Gift save failed');
            const cart = await response.json();
            if ((cart.attributes?.['Gift order'] || '') !== value ||
                (cart.attributes?.['Gift exchange request'] || '') !== detail) {
              throw new Error('Gift save not confirmed');
            }
            savedValue = value;
            giftInput.dataset.savedValue = value;
          } finally {
            clearTimeout(timeout);
          }
        }
        syncGiftFields();
        showGiftStatus(savedValue ? 'saved' : 'cleared');
      })().catch(error => {
        forceSave = true;
        showGiftStatus('error');
        throw error;
      }).finally(() => { saving = null; });
      return saving;
    };
    giftInput.removeAttribute('name');
    syncGiftFields();
    giftInput.addEventListener('change', () => {
      giftRevision++;
      persistGift().catch(() => {});
    });
    document.addEventListener('submit', async event => {
      if (event.target !== giftForm) return;
      if (resumeSubmit) {
        resumeSubmit = false;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting) return;
      giftRevision++;
      submitting = true;
      const submitter = event.submitter;
      const controls = [giftInput, ...document.querySelectorAll('button[form="nzc-cart-form"],#nzc-cart-form button[type="submit"]')];
      lockedControls = [...new Set(controls)].map(control => [control, control.disabled]);
      lockedControls.forEach(([control]) => { control.disabled = true; });
      giftForm.setAttribute('aria-busy', 'true');
      try {
        await persistGift(true);
        syncGiftFields();
        unlock();
        submitting = false;
        resumeSubmit = true;
        if (submitter && submitter.form === giftForm) giftForm.requestSubmit(submitter);
        else giftForm.requestSubmit();
      } catch (_) {
        resumeSubmit = false;
        submitting = false;
        unlock();
        showGiftStatus('error');
        giftInput.focus();
      }
    }, true);
    window.addEventListener('pageshow', async event => {
      if (saving || submitting) return;
      resumeSubmit = false;
      submitting = false;
      unlock();
      const revision = giftRevision;
      const wasChecked = giftInput.checked;
      try {
        const response = await fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' });
        if (!response.ok) throw new Error('Gift state unavailable');
        const cart = await response.json();
        if (revision !== giftRevision || saving || submitting) return;
        savedValue = cart.attributes?.['Gift order'] === 'Yes' ? 'Yes' : '';
        giftInput.checked = savedValue === 'Yes';
        giftInput.dataset.savedValue = savedValue;
        syncGiftFields();
        if (savedValue || wasChecked || event.persisted || giftStatus.textContent) {
          showGiftStatus(savedValue ? 'saved' : 'cleared');
        }
      } catch (_) {
        if (revision !== giftRevision || saving || submitting) return;
        forceSave = true;
        showGiftStatus('error');
      }
    });
  }
})();
